<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<div class="subjects">
				<div v-if="subject!=null" class="red">
					{{subject.SubjectTitle +' '+ subject.SubjectName}}<br />
					{{subject.BeginDateTime+'~'+subject.EndDateTime}}<br />
					{{subject.ShopName}}<br />
					{{subject.Count+'/'+subject.ChildCount +'人'}}<br />
					{{subject.state}}<br />
					<button type="button" :class="{'disabled':subject.state!='已结束'}" class="button"
						:disabled="subject.state!='已结束'" @click='feedBack({},0)'>课程反馈</button>
				</div>
				<div>
					<img v-if="subject.Subjectimg!=undefined"
						:src="$store.state.baseURL.replace('/api','')+'subjectImg/' +subject.Subjectimg" />
				</div>
				<div style="width: 20rem; word-wrap: break-word ;">
					<h3>[课后反馈]</h3>
					{{subject.TeacherComment}}
				</div>
				<div>
					<img v-if="subject.SubjectEndimg!=undefined && subject.SubjectEndimg"
						:src="$store.state.baseURL.replace('/api','')+'subjectImg/' +subject.SubjectEndimg" />
				</div>

			</div>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>手机号</th>
							<td>
								会员姓名
							</td>
							<th>应付金额</th>
							<th>已付金额</th>
							<th>老师评语</th>
							<th>上课照片</th>
							<td>取消报名</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index) in subjectCustomer">
							<td>{{index+1}}</td>
							<td>
								{{i.CustomerPhone}}
							</td>
							<td>
								{{i.CustomerName}}
							</td>
							<td>
								{{i.PayMoney | rmb}}
							</td>
							<td>
								{{i.Disbursements | rmb}}
							</td>
							<td style="line-height: 1.5rem;text-align: left;width: 20rem; word-wrap: break-word ;white-space: normal;">		
									{{i.TeacherComment}}
							</td>
							<td>
								<img style="width: 10rem;height: auto;"
									v-if="i.SubjectCustomerimg!=undefined && i.SubjectCustomerimg!=''"
									:src="$store.state.baseURL.replace('/api','')+'subjectImg/' +i.SubjectCustomerimg" />
							</td>
							<td>
								<button :class="{'disabled':subject.state!='已结束'}" type="button" @click='feedBack(i,1)'
									:disabled="subject.state!='已结束'" class="button">课程反馈</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="edit" v-show="Edit!=''">
			<div>
				<p>
					<label>
						<span class="red"></span>课程评语:
						<textarea v-model="TeacherComment">

					 </textarea>
					</label>
				</p>
				<p>
					<label>
						选择文件:
						<button type="button" class="button" @click="selectFile">点击选择图片</button>
						<input type="file" style="display:none;" ref='camear' />
						<span class="err">{{checkFile}}</span>
					</label>
				</p>
				<p style="text-align: center;">
					<img :src="img" ref='preview' style="width: 10rem;height: auto;" />
				</p>

				<p>
					<button class="button" :class="{'disabled':checkFile.length>0}" :disabled="checkFile.length>0"
						@click="submitfeedBack()">提交</button>
					<button class="button" @click="Edit=''">取消</button>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import j from './subjectFeedbackDetail.js'
	export default j
</script>

<style scoped>
	.content_head p {
		padding: .2rem;
	}

	.content_head img {
		width: 15rem;
		height: auto;
		vertical-align: middle;
	}

	.subjects {
		display: flex;
		flex-direction: row;
	}

	.subjects>div {
		padding: .5rem;
		letter-spacing: .1rem;
		line-height: 1.5rem;
	}
</style>
